const IDLE_TIMEOUT_MS = 5000;
const FALLBACK_DELAY_MS = 2000;

const scheduleWhenIdle = (callback: () => void) => {
    if (typeof window.requestIdleCallback === "function") {
        const idleCallbackId = window.requestIdleCallback(callback, { timeout: IDLE_TIMEOUT_MS });

        return () => {
            window.cancelIdleCallback(idleCallbackId);
        };
    }

    const timeoutId = window.setTimeout(callback, FALLBACK_DELAY_MS);

    return () => {
        window.clearTimeout(timeoutId);
    };
};

export const runAfterLoadWhenIdle = (callback: () => void) => {
    if (document.readyState === "complete") {
        return scheduleWhenIdle(callback);
    }

    let cancelScheduledCallback: (() => void) | undefined;
    const handleLoad = () => {
        cancelScheduledCallback = scheduleWhenIdle(callback);
    };

    window.addEventListener("load", handleLoad, { once: true });

    return () => {
        window.removeEventListener("load", handleLoad);
        cancelScheduledCallback?.();
    };
};
